import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="3.52002"
      width="13.2633"
      height="11.1828"
      rx="0.954076"
      fill="#DFE5F4"
    />
    <rect
      x="2.30273"
      y="5.14844"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.87074 5.55923C4.94599 5.60917 4.96789 5.7128 4.91965 5.7907L3.94558 7.36374C3.91838 7.40768 3.87294 7.43598 3.8227 7.44029C3.77246 7.4446 3.72314 7.42443 3.68932 7.38572L3.07894 6.68726C3.01897 6.61864 3.02409 6.51269 3.09038 6.45062C3.15666 6.38854 3.259 6.39384 3.31897 6.46246L3.78733 6.99841L4.64715 5.60986C4.69539 5.53196 4.79549 5.50929 4.87074 5.55923Z"
      fill="white"
    />
    <rect
      x="6.31982"
      y="5.14844"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="10.3369"
      y="5.14844"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="2.30273"
      y="8.30566"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="6.31982"
      y="8.30566"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="10.3369"
      y="8.30566"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="2.30273"
      y="11.4626"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="6.31982"
      y="11.4626"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <rect
      x="10.3369"
      y="11.4626"
      width="2.71426"
      height="2.2885"
      rx="0.38163"
      fill="#2786F5"
    />
    <path
      d="M14.4339 9.90089L11.6655 9.49383C11.504 9.46994 11.3777 9.63039 11.4383 9.78181L12.4011 12.1812C12.4756 12.3665 12.7418 12.3559 12.7995 12.1643C12.9402 11.6962 13.1844 11.0855 13.5614 10.7724C13.8042 10.5706 14.143 10.4198 14.4709 10.3102C14.6817 10.2397 14.6542 9.93322 14.4339 9.90089Z"
      fill="#323F5F"
    />
    <circle cx="4.09406" cy="3.57429" r="0.814279" fill="white" />
    <circle cx="11.1512" cy="3.57429" r="0.814279" fill="white" />
    <rect
      x="3.82275"
      y="2"
      width="0.651424"
      height="1.8457"
      rx="0.325712"
      fill="#8A8181"
    />
    <rect
      x="10.7712"
      y="2"
      width="0.651424"
      height="1.8457"
      rx="0.325712"
      fill="#8A8181"
    />
  </svg>
);

const IconBookingManagement = (props) => <Icon component={icon} {...props} />;

export default IconBookingManagement;
